import { HttpErrorResponse } from '@angular/common/http';
import { UserModel } from './../../../../../core/auth/_models/user-model.model';
import { CustomerService } from './../../../../pages/apps/utenti/customer.service';
// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'kt-delete-entity-dialog',
	templateUrl: './delete-entity-dialog.component.html'
})
export class DeleteEntityDialogComponent implements OnInit {
	// Public properties
	viewLoading = false;

	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<DeleteEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<DeleteEntityDialogComponent>,
		private customerService: CustomerService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close(false);
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
		/* Server loading imitation. Remove this */
		this.viewLoading = true;
		const user: UserModel = this.data.user;
		this.customerService.toggleUser(user).subscribe(response => {
			this.dialogRef.close(true); // Keep only this row
		}, (error: HttpErrorResponse) => {
			this.dialogRef.close(error);
			this.viewLoading = false;
		});
	}
}
